import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const BULK_UPDATE_EA_CASE_PROCESS_MANAGER = "BULK_UPDATE_EA_CASE_PROCESS_MANAGER";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ExternalAudit/bulkUpdateCaseProcessManager`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = await callMvcApi(options);

  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(BULK_UPDATE_EA_CASE_PROCESS_MANAGER, service, mock);
